import { render, staticRenderFns } from "./VerificationEmailNotification.vue?vue&type=template&id=63b053ef&scoped=true&"
import script from "./VerificationEmailNotification.vue?vue&type=script&lang=js&"
export * from "./VerificationEmailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b053ef",
  null
  
)

export default component.exports